import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REACT_ROUTER from "../../assets/img/skills/react-router.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_HEROKU from "../../assets/img/skills/heroku.jpg"
import L_CHAKRA_UI from "../../assets/img/skills/chakra-ui.svg";
import L_MATERIAL_UI from "../../assets/img/skills/material-ui-1.svg";
import L_MONGO from "../../assets/img/skills/mongodb.svg";

export const skills = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    },
    {
      link: "https://chakra-ui.com/",
      imgAltText: "Chakraui",
      imgSrc: L_CHAKRA_UI,
      skillName: "Chakra Ui",
    },
    {
      link: "https://chakra-ui.com/",
      imgAltText: "Materialui",
      imgSrc: L_MATERIAL_UI,
      skillName: "Material Ui",
    },
 
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    }, 
  ],

  hostingPlatforms: [
    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
  
    // {
    //   link: "https://www.java.com/",
    //   imgAltText: "Java",
    //   imgSrc: L_JAVA,
    //   skillName: "Java",
    // },
    
  ],
  databases: [
  
    // {
    //   link: "https://www.microsoft.com/en-us/sql-server/sql-server-2019",
    //   imgAltText: "MS-SQL",
    //   imgSrc: L_MSSQL,
    //   skillName: "MS-SQL",
    // },
    {
      link: "https://www.mongodb.com",
      imgAltText: "MongoDb",
      imgSrc: L_MONGO,
      skillName: "MongoDb",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
};
